import { render, staticRenderFns } from "./data10.vue?vue&type=template&id=c9ae2b16&scoped=true"
import script from "./data10.vue?vue&type=script&lang=js"
export * from "./data10.vue?vue&type=script&lang=js"
import style1 from "./data10.vue?vue&type=style&index=1&id=c9ae2b16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ae2b16",
  null
  
)

export default component.exports